function csrfToken(): string | null {
  return (
    document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute('content') ?? null
  );
}

// Wraps fetch with the Rails CSRF header. Callers keep full control of
// method, body and Accept — headers passed in win over the defaults.
export function csrfFetch(input: RequestInfo | URL, init: RequestInit = {}) {
  const token = csrfToken();

  return fetch(input, {
    credentials: 'same-origin',
    ...init,
    headers: {
      ...(token ? { 'X-CSRF-Token': token } : {}),
      ...init.headers,
    },
  });
}
